import { Controller } from "@hotwired/stimulus"
import EditorJS from '@editorjs/editorjs'
import Paragraph from '@editorjs/paragraph'
import List from '@editorjs/list'
import Table from '@editorjs/table'
import DragDrop from 'editorjs-drag-drop';

export default class extends Controller {
    static targets = ["section_proposal_content"]
    connect() {
        const initialContent = this.getInitialContent();

        this.contentEditor = new EditorJS({
            holder: this.section_proposal_contentTarget,
            data: initialContent,
            minHeight : 0,
            placeholder: 'Your awesome content goes here...',
            onReady: () => {
                new DragDrop(this.contentEditor);
            },
            tools: {
                paragraph: {
                    class: Paragraph,
                    inlineToolbar: true,
                },
                list: {
                    class: List,
                    inlineToolbar: true,
                },
                table: {
                    class: Table,
                    inlineToolbar: true,
                }
            },
        });

        this.element.addEventListener("submit", this.saveSectionProposalData.bind(this));
    }

    getInitialContent() {
        const initialContent = document.getElementById("section_proposal_content_hidden").value;

        if (initialContent === "") {
            return {};
        } else {
            return JSON.parse(initialContent);
        }
    }

    async saveSectionProposalData(event) {
        event.preventDefault();
        const outputData = await this.contentEditor.save();
        const hiddenInput = document.getElementById("section_proposal_content_hidden");

        hiddenInput.value = JSON.stringify(outputData);
        this.element.submit();
    }
}